import * as bootstrap from 'bootstrap';
import Helper from './helper';
import Swiper from 'swiper/bundle';
import GLightbox from "glightbox";
import mapMarkerIconUrl from '../img/icons/map-marker-red.svg?url';
import leafletScriptUrl from '../../vendor/leaflet-1.7.1/js/leaflet.js?url';

import 'swiper/css/bundle';

import.meta.glob('../img/**', { eager: true });

class App {
    constructor() {
        this.init();
    }

    init() {
        this.cookies();
        this.initStickyNavbar();
        this.initNavbarBackdrop();
        this.initNavbarDropdowns();
        this.bannerSlider();
        this.highlightSlider();
        this.timelineSlider();
        this.timelineImages();
        this.storySlider();
        this.cardSlider();
        this.internshipExpectationsSlider();
        this.glightbox();
        this.map();
        this.media();
        this.testimonials();
    }

    /**
     * Set cookie preferences
     */
    cookies() {
        let form = document.getElementById('form-cookies');

        if (form === null) {
            return false;
        }

        // Show the cookie form
        form.classList.remove('fade');

        // Add cookie selection state
        document.body.classList.add('cookie-selection');

        let options = form.querySelector('.cookies-banner__options');

        let textChecked   = 'Alle cookies accepteren';
        let textUnchecked = 'Geselecteerde cookies accepteren'

        let buttonSubmit = form.querySelector('button[type="submit"]');

        let isAllCookiesChecked = function () {
            let checked = true;

            options.querySelectorAll('.form-check-input').forEach(switchElement => {
                if (switchElement.checked === false) {
                    checked = false;
                }
            });

            return checked;
        }

        options.querySelectorAll('.form-check-input').forEach(input => {
            // Bind the change event listener to the form check input
            input.addEventListener('change', function () {
                buttonSubmit.innerText = isAllCookiesChecked() ? textChecked : textUnchecked;
            });

            // Manually create on on-change event
            let event = new Event('change');

            // Manually dispatch event
            input.dispatchEvent(event);
        });

        const collapseCookies = document.getElementById('collapse-cookies');

        collapseCookies.addEventListener('show.bs.collapse', () => {
            collapseCookies.querySelectorAll('.form-check-input:not(#cookies-functional)').forEach(input => {
                input.checked = false;
            });

            buttonSubmit.innerText = textUnchecked;
        })

        form.addEventListener('submit', function(e) {
            e.preventDefault();

            let formData = new FormData(this);

            if (e.submitter) {
                // Manually add button name and value
                formData.append(e.submitter.name, e.submitter.value);
            }

            Helper.post(this.action, formData).then(() => {
                // Remove cookie selection state
                document.body.classList.remove('cookie-selection');

                // Fade out the form
                form.classList.add('fade');

                setTimeout(function () {
                    // Reload page
                    location.reload();
                }, 1000);
            })
            .catch(error => {
                // Reject the promise
                return Promise.reject(error.statusText);
            });
        });
    }

    createPagination(element) {
        let pagination = element.querySelector('.swiper-pagination');

        if (pagination === null) {
            pagination = document.createElement('div');
            pagination.classList.add('swiper-pagination');
            element.appendChild(pagination);
        }

        return pagination;
    }

    initStickyNavbar() {
        const navbar = document.getElementById('main-navbar');

        const header = document.querySelector('header');

        if (navbar === null || header == null) {
            return false;
        }

        const scrolled = navbar.offsetHeight;

        const sticky = header.offsetHeight;

        window.addEventListener('scroll', () => {
            if (window.pageYOffset >= scrolled) {
                navbar.classList.add('scrolled');
            } else {
                navbar.classList.remove('scrolled');
            }

            if (window.pageYOffset >= sticky) {
                navbar.classList.add('sticky');
            } else {
                navbar.classList.remove('sticky');
            }
        });
    }

    initNavbarBackdrop() {
        const collapseEl = document.getElementById('main-navbar-collapse');

        if (!collapseEl) return;

        // Create backdrop element
        const backdrop = document.createElement('div');
        backdrop.classList.add('main-navbar__backdrop');
        document.body.appendChild(backdrop);

        collapseEl.addEventListener('show.bs.collapse', () => {
            backdrop.classList.add('main-navbar__backdrop--visible');
        });

        collapseEl.addEventListener('hide.bs.collapse', () => {
            backdrop.classList.remove('main-navbar__backdrop--visible');
        });

        // Close menu when backdrop is clicked
        backdrop.addEventListener('click', () => {
            bootstrap.Collapse.getInstance(collapseEl)?.hide();
        });
    }

    initNavbarDropdowns() {
        const desktopMediaQuery = window.matchMedia('(min-width: 992px)');

        document.querySelectorAll('.main-navbar .nav-item.dropdown').forEach(item => {
            const toggle = item.querySelector(':scope > .main-navbar__submenu-toggle');
            const menu = item.querySelector(':scope > .dropdown-menu');
            const link = item.querySelector(':scope > .nav-link');
            let hideTimeout = null;

            if (!link || !toggle || !menu) {
                return;
            }

            const setExpanded = expanded => {
                menu.classList.toggle('show', expanded);
                item.classList.toggle('show', expanded);
                link.classList.toggle('show', expanded);
                toggle.classList.toggle('show', expanded);
                link.setAttribute('aria-expanded', String(expanded));
                toggle.setAttribute('aria-expanded', String(expanded));
            };

            const openOnDesktop = () => {
                window.clearTimeout(hideTimeout);

                if (desktopMediaQuery.matches) {
                    setExpanded(true);
                }
            };

            const closeOnDesktop = () => {
                window.clearTimeout(hideTimeout);

                hideTimeout = window.setTimeout(() => {
                    if (desktopMediaQuery.matches && !item.matches(':hover') && !item.contains(document.activeElement)) {
                        setExpanded(false);
                    }
                }, 160);
            };

            item.addEventListener('mouseenter', openOnDesktop);
            item.addEventListener('mouseleave', closeOnDesktop);
            item.addEventListener('focusin', openOnDesktop);
            item.addEventListener('focusout', closeOnDesktop);
            item.addEventListener('show.bs.dropdown', () => setExpanded(true));
            item.addEventListener('hidden.bs.dropdown', () => setExpanded(false));

            desktopMediaQuery.addEventListener('change', () => {
                window.clearTimeout(hideTimeout);
                setExpanded(false);
            });
        });
    }

    bannerSlider() {
        document.querySelectorAll('.banner__media').forEach(element => {
            if (element.swiper) {
                return;
            }

            const hasMultipleSlides = element.querySelectorAll('.swiper-slide').length > 1;
            const backgrounds = element.querySelectorAll('.banner__parallax');
            const updateBackground = swiper => {
                backgrounds.forEach((background, index) => {
                    background.classList.toggle('is-active', index === swiper.realIndex);
                });
            };

            let autoplay = false;
            let pagination = false;

            if (hasMultipleSlides) {
                autoplay = {
                    delay: 5000,
                    disableOnInteraction: false
                };

                pagination = {
                    el: element.querySelector('.banner__pagination'),
                    clickable: true
                };
            }

            new Swiper(element, {
                slidesPerView: 1,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                speed: 1000,
                autoplay: autoplay,
                pagination: pagination,
                loop: hasMultipleSlides,
                allowTouchMove: hasMultipleSlides,
                on: {
                    init: updateBackground,
                    slideChange: updateBackground
                }
            });
        });
    }

    highlightSlider() {
        const mobileMediaQuery = window.matchMedia('(max-width: 767.98px)');

        document.querySelectorAll('.highlights__list--carousel').forEach(element => {
            let swiper = null;

            const toggleSlider = () => {
                if (mobileMediaQuery.matches && swiper === null) {
                    swiper = new Swiper(element, {
                        pagination: {
                            el: this.createPagination(element),
                            clickable: true
                        },
                        autoplay: false,
                        loop: true,
                        spaceBetween: 24,
                        slidesPerView: 'auto',
                        slidesPerGroup: 1
                    });
                } else if (!mobileMediaQuery.matches && swiper !== null) {
                    swiper.destroy(true, true);
                    element.querySelector('.swiper-pagination')?.remove();

                    swiper = null;
                }
            };

            toggleSlider();

            mobileMediaQuery.addEventListener('change', toggleSlider);
        });
    }

    timelineImages() {
        document.querySelectorAll('.timeline__images').forEach(element => {
            if (element.swiper || element.querySelectorAll('.swiper-slide').length < 2) {
                return;
            }

            new Swiper(element, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                pagination: {
                    el: element.querySelector('.swiper-pagination'),
                    clickable: true
                }
            });
        });
    }

    timelineSlider() {
        document.querySelectorAll('.timeline-slider__list').forEach(element => {
            if (element.swiper) {
                return;
            }

            const slideCount = element.querySelectorAll('.swiper-slide').length;

            const pagination = element.parentElement.querySelector('.timeline-slider__pagination');

            new Swiper(element, {
                pagination: pagination ? {
                    el: pagination,
                    clickable: true,
                    bulletElement: 'button',
                    bulletClass: 'timeline-slider__dot',
                    bulletActiveClass: 'timeline-slider__dot--active'
                } : false,
                a11y: {
                    paginationBulletMessage: 'Ga naar slide {{index}}'
                },
                centeredSlides: true,
                breakpoints: {
                    0: { slidesPerView: slideCount > 1 ? 1.15 : 1 },
                    768: { slidesPerView: slideCount > 1 ? 1.6 : 1 },
                    1200: { slidesPerView: slideCount > 1 ? 2 : 1 }
                },
                spaceBetween: 24
            });
        });
    }

    storySlider() {
        document.querySelectorAll('.stories__list').forEach(element => {
            if (element.swiper) {
                return;
            }

            const wrapper = element.querySelector('.swiper-wrapper');
            const slides = Array.from(wrapper.children);
            const pagination = this.createPagination(element);

            if (slides.length === 0) {
                return;
            }

            const getRequiredSlides = () => {
                if (slides.length < 2) {
                    return slides.length;
                }

                const slideWidth = wrapper.firstElementChild.getBoundingClientRect().width;

                const visibleSlides = Math.max(3, Math.ceil(element.clientWidth / (slideWidth + 24)));

                return visibleSlides * 2;
            };

            const ensureLoopSlides = (requiredSlides = getRequiredSlides()) => {

                while (wrapper.children.length < requiredSlides) {
                    slides.forEach(slide => wrapper.appendChild(slide.cloneNode(true)));
                }
            };

            ensureLoopSlides();

            const options = {
                pagination: {
                    el: pagination,
                    type: 'custom',
                    renderCustom: swiper => slides.map((slide, index) => {
                        const active = swiper.realIndex % slides.length === index;

                        return `<button type="button" class="swiper-pagination-bullet${active ? ' swiper-pagination-bullet-active' : ''}" data-story-slide="${index}" aria-label="Ga naar verhaal ${index + 1}"${active ? ' aria-current="true"' : ''}></button>`;
                    }).join('')
                },
                autoplay: false,
                loop: slides.length > 1,
                breakpoints: {
                    0: {
                        slidesPerView: 'auto',
                        pagination: {
                            enabled: true
                        }
                    },
                    768: {
                        slidesPerView: 3
                    },
                    992: {
                        slidesPerView: 'auto',
                        pagination: {
                            enabled: false
                        }
                    }
                },
                spaceBetween: 24,
                slidesPerGroup: 1
            };

            let slider = new Swiper(element, options);

            pagination.addEventListener('click', event => {
                const bullet = event.target.closest('[data-story-slide]');

                if (bullet) {
                    slider.slideToLoop(Number(bullet.dataset.storySlide));
                }
            });

            const observer = new ResizeObserver(() => {
                slider.update();
                const requiredSlides = getRequiredSlides();

                if (wrapper.children.length < requiredSlides) {
                    const index = slider.realIndex;
                    slider.destroy(true, true);
                    ensureLoopSlides(requiredSlides);
                    slider = new Swiper(element, { ...options, initialSlide: index });
                }
            });

            observer.observe(element);
        });
    }

    cardSlider() {
        document.querySelectorAll('.cards__list--carousel').forEach(element => {
            new Swiper('#' + element.getAttribute('id'), {
                pagination: {
                    el: this.createPagination(element),
                    clickable: true
                },
                navigation: {
                    prevEl: element.closest('section').querySelector('.cards__header-navigation-button--previous'),
                    nextEl: element.closest('section').querySelector('.cards__header-navigation-button--next')
                },
                autoplay: false,
                loop: true,
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        pagination: {
                            enabled: true
                        }
                    },
                    576: {
                        slidesPerView: 2
                    },
                    768: {
                        slidesPerView: 3
                    },
                    992: {
                        slidesPerView: 'auto',
                        pagination: {
                            enabled: false
                        }
                    }
                },
                spaceBetween: 24,
                slidesPerGroup: 1
            });
        });
    }

    internshipExpectationsSlider() {
        const mobileMediaQuery = window.matchMedia('(max-width: 767.98px)');

        document.querySelectorAll('.feature-mosaic__list').forEach(element => {
            let swiper = null;

            const toggleSlider = () => {
                if (mobileMediaQuery.matches && swiper === null) {
                    swiper = new Swiper(element, {
                        pagination: {
                            el: this.createPagination(element),
                            clickable: true
                        },
                        autoplay: false,
                        loop: false,
                        spaceBetween: 24,
                        slidesPerView: 'auto',
                        breakpoints: {
                            576: {
                                slidesPerView: 2
                            }
                        },
                        slidesPerGroup: 1
                    });
                } else if (!mobileMediaQuery.matches && swiper !== null) {
                    swiper.destroy(true, true);
                    element.querySelector('.swiper-pagination')?.remove();

                    swiper = null;
                }
            };

            toggleSlider();

            mobileMediaQuery.addEventListener('change', toggleSlider);
        });
    }

    glightbox() {
        GLightbox({
            loop: true
        });
    }

    map () {
        let container = document.getElementById('map');

        if (container === null) {
            return;
        }

        let isInitialized = false;

        const initializeMap = () => {
            if (isInitialized) {
                return true;
            }

            const Leaflet = window.L;

            if (typeof Leaflet === 'undefined') {
                return false;
            }

            isInitialized = true;

            let osm = Leaflet.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                minZoom: 4,
                maxZoom: 19,
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap contributors</a>'
            });

            let defaultCenter = new Leaflet.LatLng(52.34810011409275, 5.760644749038975);

            let defaultZoom = 9;

            if (window.innerWidth < 768) {
                defaultCenter = new Leaflet.LatLng(52.34810011409275, 6.160644749038975);

                defaultZoom = 8;
            }

            let map = new Leaflet.Map('map', {
                scrollWheelZoom: false,
                center: defaultCenter,
                zoom: defaultZoom
            });

            osm.addTo(map);

            let icon = Leaflet.icon({
                iconUrl: mapMarkerIconUrl,
                iconSize: [56, 68],
            })

            Leaflet.marker([52.34810011409275, 6.660644749038975])
                .setIcon(icon)
                .addTo(map)
                .bindPopup('<b>Hegeman Ontwikkeling B.V.</b><br />Bornerbroeksestraat 155<br />7601 BG Almelo');

            Leaflet.marker([52.48813164013653, 6.127503149053106])
                .setIcon(icon)
                .addTo(map)
                .bindPopup('<b>Hegeman VNO Bouw B.V.</b><br />Simon Stevinweg 13<br />8013 NA Zwolle');

            Leaflet.marker([52.25226117366511, 6.788117679059541])
                .setIcon(icon)
                .addTo(map)
                .bindPopup('<b>Hegeman VNO Bouw B.V.</b><br />Boekeloseweg 123<br />7553 DM Hengelo');

            Leaflet.marker([52.21109658407236, 5.969559925862265])
                .setIcon(icon)
                .addTo(map);

            const invalidateMapSize = () => {
                map.invalidateSize();
            };

            requestAnimationFrame(invalidateMapSize);
            window.setTimeout(invalidateMapSize, 100);
            window.setTimeout(invalidateMapSize, 300);
            window.setTimeout(invalidateMapSize, 800);

            window.addEventListener('load', invalidateMapSize, { once: true });
            window.addEventListener('resize', invalidateMapSize);
            window.addEventListener('orientationchange', () => {
                window.setTimeout(invalidateMapSize, 300);
            });

            return true;
        };

        if (initializeMap() === false) {
            const existingScript = document.querySelector('script[data-leaflet]');

            if (existingScript !== null) {
                existingScript.addEventListener('load', initializeMap, { once: true });

                return;
            }

            const script = document.createElement('script');
            script.src = leafletScriptUrl;
            script.async = true;
            script.dataset.leaflet = 'true';
            script.addEventListener('load', initializeMap, { once: true });

            document.head.appendChild(script);
        }
    }

    media() {
        document.querySelectorAll('.media').forEach(element => {
            const playPauseButton = element.querySelector('.media__play-pause');

            const video = element.querySelector('.media__video');

            if (playPauseButton && video) {
                // Bind the click event listened to the play-pause button
                playPauseButton.addEventListener('click', () => {
                    video.paused ? video.play() : video.pause();

                    video.classList.toggle('media__video--playing', !video.paused);
                });
            }
        });
    }

    testimonials() {
        const testimonials = document.getElementById('testimonials');

        if (testimonials === null) {
            return;
        }

        const testimonialsList = testimonials.querySelector('.testimonials__list');

        if (testimonialsList === null) {
            return;
        }

        const cols = Array.from(testimonials.querySelectorAll('.testimonials__item'));

        const startOffset = parseFloat(getComputedStyle(testimonials).getPropertyValue('--testimonials-track-start-offset')) || 0;

        const state = cols.map(col => ({
            col,
            track: col.querySelector('.testimonials__track'),
            dir: col.dataset.dir, // "up" | "down"
            y: 0,
            restY: 0,
            max: 0,
            v: 100, // px/sec tweak
        }));

        // Store original cards (so we can restore perfectly)
        const original = state.map(s => Array.from(s.track.children));

        function restoreOriginal() {
            // Put everything back exactly as it was
            state.forEach((s, index) => {
                s.track.replaceChildren(...original[index]);

                s.col.classList.remove('testimonials__item--hidden');
            });
        }

        function prependScrollClones(track, cards) {
            const clones = cards.map(card => {
                const clone = card.cloneNode(true);
                clone.dataset.testimonialsClone = 'true';
                clone.setAttribute('aria-hidden', 'true');

                return clone;
            });
            const trackStyles = getComputedStyle(track);
            const trackGap = parseFloat(trackStyles.rowGap || trackStyles.gap) || 0;
            const cloneMargin = Math.max(0, startOffset - trackGap);
            const lastClone = clones[clones.length - 1];

            if (lastClone !== undefined && cloneMargin > 0) {
                lastClone.style.marginBottom = `${cloneMargin}px`;
            }

            track.prepend(...clones);
        }

        function applyResponsiveTracks() {
            const visibleColumns = window.innerWidth < 768 ? 1 : (window.innerWidth < 1200 ? 2 : 3);

            // Always start from a clean known state
            restoreOriginal();

            if (visibleColumns < state.length) {
                state.forEach((s, index) => {
                    s.track.replaceChildren();

                    s.col.classList.toggle('testimonials__item--hidden', index >= visibleColumns);
                });

                original.flat().forEach((card, index) => {
                    state[index % visibleColumns].track.appendChild(card);
                });
            }

            state.slice(0, visibleColumns).forEach(s => {
                if (s.dir === 'down') {
                    prependScrollClones(s.track, Array.from(s.track.children));
                }
            });

            // IMPORTANT: your existing state objects reference .track nodes.
            // After moving cards, the track elements are the same, only children changed.
            // So just re-measure to update max/positions.
            measure();

            updateAutoScrollMode();
        }

        let raf = null;
        let last = 0;
        let hovering = false;

        function setTransform(s) {
            s.track.style.transform = `translate3d(0, ${startOffset - s.y}px, 0)`;
        }

        function isVisible(el) {
            return !!el.offsetParent;
        }

        function isMobile() {
            return window.innerWidth < 1200;
        }

        function getFirstRealCard(s) {
            return Array.from(s.track.children).find(child => child.dataset.testimonialsClone !== 'true');
        }

        function getRestY(s) {
            if (s.dir !== "down") {
                return 0;
            }

            const firstOriginalCard = getFirstRealCard(s);

            if (firstOriginalCard === undefined) {
                return 0;
            }

            return firstOriginalCard.offsetTop;
        }

        function alignRestPositions() {
            state.forEach(s => {
                if (!isVisible(s.col)) return;

                const firstRealCard = getFirstRealCard(s);

                if (firstRealCard === undefined) {
                    return;
                }

                const targetTop = s.col.getBoundingClientRect().top + startOffset;
                const currentTop = firstRealCard.getBoundingClientRect().top;

                s.y += currentTop - targetTop;
                s.y = Math.max(0, s.y);
                s.restY = s.y;
                s.max = Math.max(s.max, s.y);
                setTransform(s);
            });
        }

        function measure() {
            state.forEach(s => {
                if (!isVisible(s.col)) return;

                s.track.style.transition = "none";

                const overflow = s.track.scrollHeight - s.col.clientHeight;
                s.max = Math.max(0, overflow);

                const restY = getRestY(s);

                s.max = Math.max(s.max, restY);
                s.y = restY;
                setTransform(s);
            });

            alignRestPositions();
        }

        function tick(ts) {
            if (!hovering) return;

            const dt = Math.min(0.05, (ts - last) / 1000 || 0);
            last = ts;

            state.forEach(s => {
                if (!isVisible(s.col)) return;
                if (s.max <= 0) return;

                const dir = (s.dir === "up") ? +1 : -1;
                s.y = Math.min(s.max, Math.max(0, s.y + dir * s.v * dt));
                setTransform(s);
            });

            raf = requestAnimationFrame(tick);
        }

        function start() {
            if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
                return;
            }

            if (hovering) {
                return;
            }

            hovering = true;

            state.forEach(s => {
                if (!isVisible(s.col)) {
                    return;
                }

                s.track.style.transition = "none";
            });

            cancelAnimationFrame(raf);
            last = performance.now();
            raf = requestAnimationFrame(tick);
        }

        function stopAndReturn() {
            hovering = false;
            cancelAnimationFrame(raf);

            state.forEach(s => {
                if (!isVisible(s.col)) return;
                s.track.style.transition = "transform 700ms cubic-bezier(.2,.8,.2,1)";
                s.y = s.restY;
                setTransform(s);
            });
        }

        let mobileAutoScrollActive = false;

        function updateAutoScrollMode() {
            if (isMobile()) {
                // Start auto-scroll on mobile
                if (!mobileAutoScrollActive) {
                    start();
                    mobileAutoScrollActive = true;
                }

                // Disable hover listeners (mobile safety)
                testimonialsList.removeEventListener('mouseenter', start);
                testimonialsList.removeEventListener('mouseleave', stopAndReturn);
            }
            else {
                // Desktop behavior
                if (mobileAutoScrollActive) {
                    stopAndReturn();
                    mobileAutoScrollActive = false;
                }

                testimonialsList.addEventListener('mouseenter', start);
                testimonialsList.addEventListener('mouseleave', stopAndReturn);
            }
        }

        testimonialsList.addEventListener('mouseenter', start);
        testimonialsList.addEventListener('mouseleave', stopAndReturn);

        window.addEventListener('resize', applyResponsiveTracks);

        applyResponsiveTracks();

        setTimeout(applyResponsiveTracks, 100);
    }
}

window.addEventListener('load', () => new App());
